import { type Region, getRegion } from './RegionUtil';
import appIconCn from '@/assets/img/template000_data0000_img1.png';
import appIconGlobal from '@/assets/img/template000_data0000_img1_global.png';

// ============================================================
// 可配置区域 —— 后续新增区域化资源在此扩展
// ============================================================

const APP_ICONS: Record<Region, string> = {
  cn: appIconCn,
  global: appIconGlobal,
};

export function getAppIcon(): string {
  return APP_ICONS[getRegion()];
}
